<template>
  <div>
    <el-col :span="7">
      <TenantidListView ref="external" @select="bindSelect"></TenantidListView>
    </el-col>
    <el-col :span="17">
      <div>
        <el-table
          :data="tableData"
          :height="tableHeight(-12)"
          size="mini"
          stripe
          border
          :span-method="objectSpanMethod"
          style="width: 100%;">
          <el-table-column
            prop="paragroup"
            width="100"
            label=""
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.paragroup=='webset'">前端</span>
              <span v-else-if="scope.row.paragroup=='apiset'">后台</span>
              <span v-else-if="scope.row.paragroup=='wxpay'">微信</span>
              <span v-else-if="scope.row.paragroup=='zfbpay'">支付宝</span>
              <span v-else-if="scope.row.paragroup=='sms'">短信</span>
              <span v-else-if="scope.row.paragroup=='sfexpress'">顺丰</span>
              <span v-else-if="scope.row.paragroup=='other'">其它</span>
              <span v-else>{{scope.row.paragroup}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="参数"
            align="left"
            header-align="center"
            width="130"
            prop="fiscalsysguid">
          </el-table-column>
          <el-table-column
            prop="paraname"
            align="left" header-align="center"
            width="300"
            label="描述">
          </el-table-column>
          <el-table-column
            prop="paracontent"
            label="内容"
            align="left" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <ParameterMaintainEdit ref="ParameterMaintainEdit" @bindGuid="bindGrid"></ParameterMaintainEdit>
    </el-col>
  </div>
</template>

<script>
  import TenantidListView from '@/components/sysmanage/TenantidListView';
  import ParameterMaintainEdit from '@/components/sysmanage/parametermaintain/ParameterMaintainEdit';
  import {parameterMaintainList} from '@/api/sysmanage/sysmanage';

  export default {
    name: 'ParameterMaintainList',
    data() {
      return {
        formLabelWidth: '120px',
        dialogFormVisible: false,
        tenantid: '',
        independentserial: '',
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 100,
          total: 0
        },
        tableData: [],
        spanArr: [],
        pos: 0
      }
    },
    methods: {
      //table合并
      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 0) {
          const _row = this.spanArr[rowIndex];//从处理完的数组里获取
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col //相当于给给表格加上rowspan,colspan属性
          }
        }

      },
      //由于数据是动态的，所以页面加载时需要调用下面的方法，根据后台数据处理以知道要合并的行/列
      //得到的spanArr数组表示某一行所需要合并的列数
      getSpanArr(data) {
        this.spanArr = [];//定义在vue的data中
        if (data == null) {
          return;
        }
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0;
          } else {
            if (data[i].paragroup === data[i - 1].paragroup) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
        }

      },
      handleEdit(index, row) {
        this.$refs.ParameterMaintainEdit.show()
        this.$refs.ParameterMaintainEdit.initData(row)
      },
      bindSelect(tenantid) {
        this.tenantid = tenantid || ""
        this.bindGrid();
      },
      bindGrid() {
        parameterMaintainList({
          isshow: 1,
          sort: 'paragroup',
          tenantid: this.tenantid,
        }).then(response => {
          this.tableData = response.data.obj
          if (this.tableData.length > 0)
            this.getSpanArr(this.tableData)
        }).catch((error) => {
          console.log(error)
        });
      },

    },
    mounted() {

    },
    components: {
      TenantidListView,
      ParameterMaintainEdit
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/sysmanage/parametermaintain/ParameterMaintainList.vue